<template>
    <div class="content_div">
        <el-card>
            <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
                <el-tab-pane v-for="item in shopList" :label="item.name" :key="item.id" :name="item.id"></el-tab-pane>

                <!--商品-->
                <el-form :inline="true" :model="query" class="demo-form-inline" STYLE="margin-bottom: 20px;">
                    <el-form-item label="商品名称" clearable>
                        <el-input class="input_class" v-model="query.title" auto-complete="off" placeholder="请输入商品名称"></el-input>
                    </el-form-item>
                    <el-form-item label="上架状态" clearable>
                        <el-select v-model="query.status" placeholder="请选择上架状态">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="上架" value="2"></el-option>
                            <el-option label="下架" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="loadGoodsByShopId">查询</el-button>
                    <el-button type="success" @click="btnInsert(null,0)">新增</el-button>
                </el-form>
                <el-table
                    :data="dataList"
                    border>
                    <el-table-column type="index" label="编号" width="80"/>
                    <el-table-column prop="coverUrl" label="商品图片" width="130px">
                        <template slot-scope="scope">
                            <el-image :src="filePre+scope.row.coverUrl" style="width: 100px; height: 100px"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="商品名称"/>

                    <el-table-column prop="businessType" label="用餐类型" width="120">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.businessType===1">员工餐</el-tag>
                            <el-tag type="success" v-if="scope.row.businessType===2">客户餐</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="type" label="商品类型">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.type===1">早餐</el-tag>
                            <el-tag type="danger" v-if="scope.row.type===2">午餐</el-tag>
                            <el-tag type="success" v-if="scope.row.type===3">晚餐</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="introduction" label="商品介绍"/>
                    <el-table-column prop="introduction" label="商品介绍"/>
                    <el-table-column prop="price" label="商品价格" width="120"/>
                    <el-table-column prop="status" label="上架状态" align="center" width="120">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.status"
                                       :active-value="2" :inactive-value="1"
                                       @change="handleJobStatus(scope.row.id,scope.row.status)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间"/>
                    <el-table-column align="center" label="操作" width="210">
                        <template slot-scope="scope">
                            <el-button size="small" type="info" @click="btnInsert(scope.row,2)">修改</el-button>
                            <el-button size="small" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination style="margin-top:10px;"
                               background
                               layout="total,prev, pager, next"
                               @current-change="currentChange"
                               :total="total">
                </el-pagination>
            </el-tabs>
        </el-card>

        <el-dialog :close-on-click-modal="false" title="操作" :visible="isShowDialogFlag" @close="close">
            <el-form label-width="120px" :model="data" ref="data" :rules="rules">
                <el-form-item label="商品图片" prop="logo">
                    <square-crop-upload
                        :key="data.id"
                        v-model="data.coverUrl"
                        @success="handleSuccess"
                        @remove="handleRemove"
                        :max-size="1024"
                    />
                </el-form-item>
                <el-form-item label="商品名称" prop="title">
                    <el-input v-model="data.title" maxlength="30" auto-complete="off" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="商品介绍" prop="introduction">
                    <el-input v-model="data.introduction" auto-complete="off" placeholder="请输入商品介绍"></el-input>
                </el-form-item>
                <el-form-item label="商品类型" prop="type" clearable>
                    <el-select v-model="data.type" placeholder="请选择商品类型">
                        <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <!--用餐类型：1员工餐；2客户餐-->
                <el-form-item label="用餐类型" prop="businessType" clearable>
                    <el-select v-model="data.businessType" placeholder="请选择用餐类型">
                        <el-option label="员工餐" :value=1></el-option>
                        <el-option label="客户餐" :value=2></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品价格" prop="price">
                    <el-input-number maxLength="3" v-model="data.price" :min="1" :max="100" label="请输入商品价格"></el-input-number>
                </el-form-item>
                <el-form-item label="当天供货数量">
                    <el-input-number v-model="data.num" :min="1" :max="300" label="请输入当天供货数量"></el-input-number>
                </el-form-item>
                <!--排序-->
                <el-form-item label="排序" prop="sort">
                    <el-input-number v-model="data.sort" :min="1" :max="1000" auto-complete="off" placeholder="请输入排序"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click='close'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {reqListShop} from "../../../../api/core/Shop";
import {reqChangeGoodsStatus, reqDeleteGoodsById, reqInsertGoods, reqListGoods, reqUpdateGoods} from "../../../../api/core/Goods";
import SquareCropUpload from "../../../../components/core/images/SquareCropUpload.vue";
import {reqUploadFile} from "../../../../api/system";
import global from "../../../../api/global";

const typeList = [
    {id: 1, name: '早餐'},
    {id: 2, name: '午餐'},
    {id: 3, name: '晚餐'},
];
export default {
    name: "User",
    components: {SquareCropUpload},
    async created() {
        await this.loadShopList();
    },
    methods: {
        //加载店铺列表
        async loadShopList() {
            let data = await reqListShop();
            this.shopList = data;
            if (data.length > 0) {
                this.data.shopId = data[0].id;
                this.query.shopId = data[0].id;
                this.activeName = data[0].id;
                await this.loadGoodsByShopId();
            }
        },
        //切换店铺
        async handleClick(tab, event) {
            const id = tab.name;
            this.query.shopId = id;
            this.data.shopId = id;
            await this.loadGoodsByShopId();
        },
        async loadGoodsByShopId() {
            //加载店铺的商品
            this.dataList = [];
            let data = await reqListGoods(this.query);
            this.dataList = data.records;
            this.total = data.total;
        },
        currentChange(num) {
            this.query.currentPage = num;
            this.loadGoodsByShopId();
        },
        btnInsert(row, type) {
            if (type === 0) {
                this.data = {shopId: this.query.shopId};
            } else if (type === 1) {
                this.data = {shopId: this.query.shopId};
            } else {
                this.data = JSON.parse(JSON.stringify(row));
            }
            this.isShowDialogFlag = true;
        },
        async close() {
            this.isShowDialogFlag = false;
        },
        async handleSuccess({blob, base64, name}) {
            // 直接上传 blob 到服务器
            const form = new FormData()
            form.append('file', blob, name)
            let data = await reqUploadFile(form);
            this.data.coverUrl = data;
            this.$message.success('上传成功')
        },
        handleRemove() {
            this.data.coverUrl = ''
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    let result = !this.data.id ? await reqInsertGoods(this.data) : await reqUpdateGoods(this.data);
                    this.$message.success("操作成功");
                    await this.close();
                    await this.loadGoodsByShopId();
                }
            })
        },
        async btnDelete(id) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await reqDeleteGoodsById({id: id});
                this.$message.success("操作成功");
                this.query.currentPage = 1
                await this.loadGoodsByShopId();
            });
        },
        async handleJobStatus(id, status) {
            await reqChangeGoodsStatus({id: id, status: status});
            this.$message.success('操作成功');
            await this.loadGoodsByShopId();
        }
    },
    data() {
        return {
            shopList: [],
            activeName: null,
            isShowDialogFlag: false,
            total: 0,
            dataList: [],
            query: {
                shopId: null,
                currentPage: 1,
                pageSize: 10
            },
            filePre: global.preview_path_url,
            data: {
                id: null,
                price: 0,
                sort: 10,
                num: 0,
                coverUrl: null,
                shopId: null,
            },
            typeList: typeList,
            rules: {
                title: [
                    {required: true, message: '请输入商品名称', trigger: 'blur'},
                ],
                introduction: [
                    {required: true, message: '请输入商品介绍', trigger: 'blur'},
                ],
                type: [
                    {required: true, message: '请选择商品类型', trigger: 'change'},
                ],
                businessType: [
                    {required: true, message: '请选择用餐类型', trigger: 'change'}
                ],
                price: [
                    {required: true, message: '请输入价格', trigger: 'blur'},
                    {type: 'number', message: '价格必须为数字值', trigger: 'blur'}
                ],
                num: [
                    {required: true, message: '请输入数量', trigger: 'blur'},
                    {type: 'number', message: '数量必须为数字值', trigger: 'blur'}
                ],
                sort: [
                    {required: true, message: '请输入排序', trigger: 'blur'},
                    {type: 'number', message: '排序必须为数字值', trigger: 'blur'}
                ]
            }
        }
    },
}
</script>
